import React, { useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col } from "react-bootstrap";
import { Box, Button } from "@mui/material";
import InternshipStatistics from "./InternshipStatistics";
import PostScoreStatistics from "./PostScoreStatistics";
import ApplicationCadidatesChart from "./ApplicationCadidatesChart";
import fileIcon from "../../assets/img/fileIcon.png";
import applicantIcon from "../../assets/img/applicantIcon.png";
import DashboardCards from "./DashboardCards";
import chatIcon from "../../assets/img/chatIcon.png";
import GenderDistributionChart from "./GenderDistributionChart";
import usePostsChartData from "hooks/useApplications";
import useFetchRecruiter from "hooks/useFetchRecruiter";
import useNbrPostsApplicants from "hooks/useNbrPostsApplicants";
import useHiredApplicationsCount from "hooks/useHiredApplicationsCount";
import useUserId from "hooks/useUserId";
import LoadingErrorWrapper from "../../components/ErrorWrapper/LoadingErrorWrapper"
import { TitleTypography } from "StyledTypography/StyledTypography";
import { useTranslation } from "react-i18next";
import { useTour } from "context/TourContext";
import useFetchUser from "hooks/useFetchUser";

function Dashboard() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const userId = useUserId();
  const { data, loadingCard, error } = usePostsChartData();
  const { formData, loading: recruiterLoading, error: recruiterError } = useFetchRecruiter();
  const { posts, applicants, disscussions, ai_processed_resumes } = useNbrPostsApplicants();
  const { hiredCount, loading: hiredLoading, error: hiredError } = useHiredApplicationsCount();
  const { t } = useTranslation();

  return (
    <Box
    className='nav-item-dashboard'
    sx={{ width: '100%', px: { xs: 2, sm: 3, md: 4 } }}>
      <div className="content">
     
        {/* <Box sx={{ mb: 4 }}>
          <Button 
            className="start-tour-button"
            variant="contained" 
            startIcon={<Map />}
            onClick={handleStartTour}
            size="large"
          >
            Start Dashboard Tour
          </Button>
        </Box> */}

        <div
          className="dashboard-cards"
          style={{
            marginTop: '2rem',
            marginBottom: '2rem',
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            gap: '1rem'
          }}>
          <Box className='dashboard-card-1'>
            <DashboardCards
              icon={fileIcon}
              title={t('dashboard.cards.offers_posted')}
              number={posts}
            />
          </Box>
          <Box className='dashboard-card-2'>
            <DashboardCards
              icon={fileIcon}
              title={t('dashboard.cards.number_of_applicants')}
              number={applicants}
            />
          </Box>
          <Box className='dashboard-card-3'>
            <DashboardCards
              icon={applicantIcon}
              title={t('dashboard.cards.total_interviews')}
              number={disscussions}
            />
          </Box>
          <Box className='dashboard-card-4'>
            <DashboardCards
              icon={applicantIcon}
              title='Candidats recrutés'
              number={hiredCount}
            />
          </Box>
          <Box className='dashboard-card-5'>
            <DashboardCards
              icon={chatIcon}
              title={t('dashboard.cards.scraped_resumes')}
              number={ai_processed_resumes}
              tooltipText={t('dashboard.cards.scraped_resumes_tooltip')}
            />
          </Box>
        </div>

        <Row className="g-4">
          <Col xs={12} md={8} className="graph-1">
            <Box sx={{ height: { xs: 300, sm: 350, md: 400 } }}>
              <LoadingErrorWrapper loading={loadingCard} error={error}>
                <ApplicationCadidatesChart postsData={data} />
              </LoadingErrorWrapper>
            </Box>
          </Col>
          <Col xs={12} md={4} className="graph-2">
            <Box sx={{ height: { xs: 300, sm: 350, md: 400 } }}>
              <LoadingErrorWrapper loading={recruiterLoading} error={recruiterError}>
                <PostScoreStatistics userId={userId.userId} apiUrl={apiUrl} />
              </LoadingErrorWrapper>
            </Box>
          </Col>
        </Row>

        <Row className="g-4" style={{ marginTop: '2rem' }}>
          <Col xs={12} md={4} className="graph-3">
            <Box sx={{ height: { xs: 300, sm: 350, md: 400 } }}>
              <LoadingErrorWrapper loading={recruiterLoading} error={recruiterError}>
                <GenderDistributionChart userId={userId.userId} />
              </LoadingErrorWrapper>
            </Box>
          </Col>
          <Col xs={12} md={8} className="graph-4">
            <Box sx={{ height: { xs: 300, sm: 350, md: 400 } }}>
              <LoadingErrorWrapper loading={recruiterLoading} error={recruiterError}>
                <InternshipStatistics userId={userId.userId} apiUrl={apiUrl} />
              </LoadingErrorWrapper>
            </Box>
          </Col>
        </Row>
      </div>
    </Box>
  );
}

export default Dashboard;